import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getAgeOnOtherPlanets } from '../../utils';
import './PlanetsAge.scss';

export const PlanetsAge = () => {
  const [dateOfBirth, setDateOfBirth] = useState(() => new Date('1990-01-01'));
  const [planets, setPlanets] = useState(() =>
    getAgeOnOtherPlanets(dateOfBirth)
  );
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setPlanets(() => getAgeOnOtherPlanets(dateOfBirth));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [dateOfBirth]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Age on Other Planets Calculator</h2>
        <p className='mb-4'>
          Calculate how old you would have been on other planets of the solar
          system
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select Your Date of Birth'
            initDate={dateOfBirth}
            setDate={setDateOfBirth}
            maxDate={new Date()}
          />
          <button className='btn btn-success d-block w-100 py-2 fw-bold' onClick={calculate}>
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Your age in the solar system is:</h4>
          {planets.map((planet, index) => (
            <p
              className={planets.length === index + 1 ? 'mb-0' : 'mb-2'}
              key={planet.name}
            >
              On <b>{planet.name}</b> you are {planet.years} old
            </p>
          ))}
        </Result>
        <section className='info mt-4'>
          <h4>Why is your age different on other planets?</h4>
          <p>
            <b>A day</b> is the length of time it takes a planet to complete one
            full rotation on it’s axis.
            <br /> <b>A year</b> is how long it takes for a planet to revolve
            once around the Sun.
          </p>
          <p>
            The calculation is based on earth days and not "earth years" because
            an earth year is not a whole number is (1 year = 365,256).
          </p>
          <div className='table-responsive'>
            <table className='table table-bordered mb-0'>
              <thead>
                <tr className='row-1 odd'>
                  <th scope='col'>Planet</th>
                  <th scope='col'>Rotation period</th>
                  <th scope='col'>Orbit period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope='row'>Mercury</th>
                  <td>58.646 earth days</td>
                  <td>87.97 earth days</td>
                </tr>
                <tr>
                  <th scope='row'>Venus</th>
                  <td>243.018 earth days</td>
                  <td>224.70 earth days</td>
                </tr>
                <tr>
                  <th scope='row'>Earth</th>
                  <td>0.99726968 earth days</td>
                  <td>365.26 earth days</td>
                </tr>
                <tr>
                  <th scope='row'>Mars</th>
                  <td>1.026 earth days</td>
                  <td>1.8808476 earth years</td>
                </tr>
                <tr>
                  <th scope='row'>Jupiter</th>
                  <td>0.41354 earth days</td>
                  <td>11.862615 earth years</td>
                </tr>
                <tr>
                  <th scope='row'>Saturn</th>
                  <td>0.444 earth days</td>
                  <td>29.447498 earth years</td>
                </tr>
                <tr>
                  <th scope='row'>Uranus</th>
                  <td>0.718 earth days</td>
                  <td>84.016846 earth years</td>
                </tr>
                <tr>
                  <th scope='row'>Neptune</th>
                  <td>0.671 earth days</td>
                  <td>164.79132 earth years</td>
                </tr>
                <tr>
                  <th scope='row'>Pluto</th>
                  <td>6.387 earth days</td>
                  <td>247.92065 earth years</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <MoreCalculators />
    </>
  );
};
